import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/stable";
// import 'react-app-polyfill/ie11'; // For IE 11 support
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// window.apiurl = "http://pclinic.ritzyware.net:3001";
window.apiurl = "https://api.ariv.live";
window.fronturl = "https://ariv.live";
window.user = JSON.parse(localStorage.getItem("user"))
  ? JSON.parse(localStorage.getItem("user"))
  : null;
window.tinyAPIKEY = "1yhzeqboi14r5pt02pnmclmduzw3tvqaurfdkicsox1lu119"; // "e8w755v72e92ytu4phfw2z4wgycbeq7x2twygyk0umom9ot3";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
